<div
  class="shared-axis-encoding-container"
  [class.dragging]="isDraggable"
  [class.dual-axis-primary]="isDualAxisRelative"
  [class.dual-axis]="isDualAxis"
>
  <div class="dual-axis-connector" *ngIf="isDualAxis"></div>
  <div
    class="header"
    [class.dual-axis]="isDualAxis"
    (mouseenter)="onHeaderMouseEnter()"
    (mouseleave)="onHeaderMouseLeave()"
  >
    {{ groupName }}
    <capra-icon icon="icon-caret-down" [matMenuTriggerFor]="sharedAxisMenu"></capra-icon>
  </div>
  <div
    class="field-list"
    [class.single]="hasSingleField"
    [class.dragging]="isDraggable"
    [class.dual-axis-primary]="isDualAxisRelative"
    dndDropzone
    [dndDisableDropIf]="isDisallowedField"
    [dndAllowExternal]="true"
    (dndDrop)="onDropItem($event)"
  >
    <div class="placeholder-field" dndPlaceholderRef>
      <div class="cursor-left"></div>
      <div class="cursor-right"></div>
    </div>
    <div
      *ngFor="let field of fields; trackBy: trackById"
      class="field"
      [dndDraggable]="field"
      dndEffectAllowed="move"
      (dndStart)="onDragStart($event, field)"
      (dndEnd)="onDragEnd($event, field)"
    >
      <div
        class="field-dropzone"
        dndDropzone
        [dndDisableDropIf]="isDisallowedField"
        [dndAllowExternal]="true"
        (dndDrop)="onFieldDrop($event, field)"
      ></div>
      <mode-encoding-field-single
        (update)="childFieldUpdated($event)"
        (remove)="removeField($event)"
        (getBinSize)="onGetBinSize($event)"
        [encoding]="encoding"
        [field]="field"
        [fieldFormatMap]="fieldFormatMap"
        [format]="format"
        [model]="model"
        [view]="view"
        [viewName]="queryToken"
        [vizToken]="vizToken"
        [binSizeToFieldMap]="binSizeToFieldMap"
        [allowScalars]="true"
        [allowAggregates]="true"
        [allowDiscrete]="true"
        [allowContinuous]="true"
        [chartType]="chartType"
      ></mode-encoding-field-single>
    </div>
  </div>
</div>
<div
  class="border"
  [class.highlight]="isHeaderHover"
  [class.dual-axis-primary]="isDualAxisRelative"
  [class.dual-axis]="isDualAxis"
></div>
<mat-menu #sharedAxisMenu="matMenu" class="select-menu shared-axis-menu">
  <button mat-menu-item (click)="goToFormat()">Format...</button>
  <button mat-menu-item (click)="ungroupSharedAxis()">Ungroup shared axis</button>
  <mat-divider></mat-divider>
  <button
    mat-menu-item
    *ngIf="canBeDualAxis && !isDualAxisRelative"
    [class.selected]="isDualAxis"
    (click)="toggleDualAxis()"
  >
    <capra-icon icon="icon-check" *ngIf="isDualAxis"></capra-icon>Dual axis
  </button>

  <button mat-menu-item (click)="removeEntireGroup()">Remove</button>
</mat-menu>
